import {
  Box,
  CustomTheme,
  FormControl,
  FormHelperText,
  InputLabel,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';
import { IFormField } from './interfaces';
import ErrorIcon from '@mui/icons-material/Error';

export const FormField: React.FC<IFormField> = ({
  children,
  label,
  helperText,
  error,
  flex,
  required = false,
  inline = false,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  return (
    <Stack
      direction={inline ? 'row' : 'column'}
      alignItems={inline ? 'center' : undefined}
      gap="5px"
      sx={{
        width: '100%',
        position: 'relative',
      }}
      flex={flex}
    >
      <Typography
        component="label"
        sx={{
          width: '40%',
          fontSize: '.9rem',
          fontWeight: 'bold',
        }}
        color={error ? 'error' : 'text.secondary'}
      >
        {label}
        {required && (
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              fontWeight: 'bold',
              color: 'primary.main',
            }}
          >
            *
          </Typography>
        )}
      </Typography>

      <FormControl
        sx={{
          flexGrow: 1,
        }}
      >
        {children}
        {error && (
          <FormHelperText error>
            <Stack direction="row" gap="4px">
              <ErrorIcon
                sx={{
                  mt: '2px',
                  width: '14px',
                  height: '14px',
                }}
              />{' '}
              <Box>{error}</Box>
            </Stack>
          </FormHelperText>
        )}
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Stack>
  );
};
